import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.js';
var hasDom = function () {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function';
};
var hasDom$1 = /*@__PURE__*/getDefaultExportFromCjs(hasDom);
export { hasDom$1 as default };
